const scheduleAll = {
  err_unexpected_error: 'Returned when an unexpected exception occurs',
  err_fetching_interview_config:
    "When interview configuration data can't be fetched",
  err_missing_ats_job_id: 'Missing job ID in the request',
  err_missing_ats_job_stage_id: 'Missing job stage ID in the request',
  err_missing_ats_job_stage_action_ids:
    'Missing job stage action IDs in the request',
  err_invalid_ats_job_stage_action_ids:
    'Job stage action IDs are not in the correct format (should be array)',
  err_required_more_than_one_job_stage_action:
    'At least two job stage actions are required',
  err_ats_job_not_found: 'The specified job was not found',
  err_ats_job_stage_not_found: 'The specified job stage was not found',
  err_missing_job_stage_action_ids:
    'Some specified job stage action IDs were not found',
  err_missing_ats_contact_id: 'Missing contact ID in the request',
  err_missing_timezone: 'Missing timezone parameter',
  err_invalid_timezone: 'The provided timezone is invalid',
  err_primary_recruiter_calendar_not_connected:
    "When the primary recruiter's calendar isn't connected",
  err_unexpected_error_worker: 'some error in the worker',
  err_invalid_date_range: 'Ambiguous or contradictory date logic',
  err_no_available_slots: 'All times are excluded after filtering',
  err_all_days_excluded: 'Day exclusions eliminate all valid options',
  err_input_unclear:
    'The input provided is unclear or invalid. Please review and try again.',
};

export default scheduleAll;
